export const iconFontAwesomeAstronomySatellite = (
	<i className="fa-solid fa-satellite"></i>
);
